import 'is-in-viewport';

$( function() {
	animateInViewport();
} );

$( window ).scroll( function() {
	setTimeout( function() {
		animateInViewport();
	}, 100 );
} );

export function animateInViewport() {
	$( '.move-up-in-viewport, .move-down-in-viewport, .move-left-in-viewport, .move-right-in-viewport, .fade-in-in-viewport, .zoom-in-in-viewport, .active-in-viewport, .full-width-in-viewport, .full-height-in-viewport' ).each( function() {
		var $this = $( this );

		const $lazyloadImage = $this.find( '.lazyload' );

		if ( $this.is( ':in-viewport' ) ) {
			$this.addClass( 'active' );

			if ( $lazyloadImage && !$this.hasClass( 'loaded' ) ) {
				$lazyloadImage.attr( 'src', $lazyloadImage.attr( 'data-src' ) );
				$this.addClass( 'loaded' );
			}
		}
	} );
}
